import React from "react";
import styled from "styled-components";
import { TextProps } from "../../../types";
import Tooltip from "../../tooltip";
import { Color } from "../../../constants/color";
import Label from "../../label";
import { ComponentPropsWithoutRef } from "react";

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.4rem;
  text-align: center;
  color: ${Color.LIGHT_BLUE};
  font-weight: normal;
  font-size: 14px;
  text-transform: uppercase;
`;

const LabelWrapper = styled.div<{
  $textAlign?: string;
}>`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => (props.$textAlign ? "unset" : "center")};
`;

const Input = styled.input`
  margin: auto;
  width: 60%;
  height: 35px;
  border-radius: 18px;
  border-style: hidden;
  box-shadow: inset 0 0 4px 2px #e2e2e2;
  text-align: center;
  background-color: ${Color.CERAMIC};
`;

function Textbox({
  label,
  alt,
  autocomplete,
  form,
  name,
  defaultValue,
  placeholder,
  type,
  tooltip,
  tooltipText,
  onChange,
  required,
  edit,
  textAlign,
  onKeyUp,
  ...rest
}: TextProps & ComponentPropsWithoutRef<"input">) {
  return (
    <InputWrapper>
      <LabelWrapper $textAlign={textAlign}>
        <Label
          text={label}
          textAlign={textAlign}
          paddingLeft={textAlign === "left" ? 20 : undefined}
        />
        {tooltip && tooltipText && (
          <Tooltip title={tooltipText.title} text={tooltipText.text} />
        )}
      </LabelWrapper>
      <Input
        /*
         Il nome accessibile del campo.

         L'etichetta qui sopra e' uno `styled.div`, non un elemento `<label>`: a schermo si
         legge, ma per un lettore di schermo non etichetta niente, e il campo restava senza
         nome (BUG-22). Un `htmlFor` non basterebbe, perche' un div non puo' etichettare.
         Il segnaposto e' l'ultima risorsa: e' cio' che c'e' quando l'etichetta manca, ed e'
         anche cio' che sparisce appena si inizia a scrivere.
        */
        aria-label={label || placeholder}
        alt={alt}
        form={form}
        autoComplete={autocomplete}
        name={name}
        defaultValue={defaultValue}
        placeholder={placeholder}
        type={type}
        onChange={onChange}
        onKeyUp={(e) => {
          if (e.key === "Enter" && onKeyUp) {
            onKeyUp(e);
          }
        }}
        required={required ?? true}
        readOnly={edit !== undefined ? !edit : false}
        {...rest}
      />
    </InputWrapper>
  );
}

export default Textbox;
